/**
 * @generated SignedSource<<368f4a96402f1b46c979e13f3675f8ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapFilterList_filterList",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "filters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapFilter_filter"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MapFilterList",
  "abstractKey": null
};

node.hash = "16232970b6c335f85e432c877ce7f4dc";

module.exports = node;
